import { render } from "./index.vue?vue&type=template&id=9f29d2c2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9f29d2c2&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__